import { useState } from 'react';

import { SubmitButton } from '@/components/submit-button';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

type Props = {
  isPending: boolean;
};

export const AgentDetailFooter = ({ isPending }: Props) => {
  const [deleteAlertOpen, setDeleteAlertOpen] = useState(false);

  return (
    <>
      <div className="sticky bottom-0 left-0 right-0 z-40 bg-background/80 border-t border-border mt-6 backdrop-blur-xs">
        <div className="flex justify-end gap-3 py-4">
          <Button
            type="button"
            variant="outline"
            disabled={false}
            onClick={() => setDeleteAlertOpen(true)}
          >
            Cancel
          </Button>

          <SubmitButton isPending={isPending} label="Save changes" className="flex" />
        </div>
      </div>

      {/* Discard Changes Dialog */}
      <AlertDialog open={deleteAlertOpen} onOpenChange={setDeleteAlertOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Unsaved changes</AlertDialogTitle>
            <AlertDialogDescription>
              You have unsaved changes. Would you like to keep editing or discard them?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={() => {}}>Keep editing</AlertDialogCancel>
            <Button variant="destructive" onClick={() => setDeleteAlertOpen(false)}>
              Discard changes
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
